// The stage: one board scaled to fit it whole, on a phone's page the board
// at the page's width, or, on a narrow screen given the board view, every
// board stacked at the screen's width (presentation_controller.js
// sets out the ways to look at a deck). And whether this screen asks for
// less motion, which a board turning over and a card being carried heed.

const BOARD_WIDTH = 960;
const BOARD_HEIGHT = 540;
const STACKED_BELOW = 640;
const PHONE_MARGIN = 16;

export default {
  shouldStack() {
    if (this.remoteValue || this.phoneValue) return false;
    return window.matchMedia(`(max-width: ${STACKED_BELOW}px)`).matches;
  },

  // Largest scale at which the whole board fits, with a gutter of stage
  // colour around it. On a narrow screen the boards stack instead, each at
  // the width of the screen.
  fit() {
    if (!this.hasStageTarget || !this.hasCanvasTarget) return;
    // On a phone's page the board is drawn at the page's width, less its
    // margins and the plate's hairlines (deck/phone.css).
    if (this.phoneValue) {
      const width = this.stageTarget.clientWidth - 2 * PHONE_MARGIN - 2;
      this.element.style.setProperty("--deck-phone-zoom", Math.max(width / BOARD_WIDTH, 0.1).toFixed(4));
      return;
    }

    const stacked = this.shouldStack();
    if (stacked !== this.stacked) {
      this.stacked = stacked;
      // Stacking is this window's own layout, not a page turn: nothing is
      // sent to the phone or the other windows.
      this.showSlide(this.indexValue, false, false);
    }
    this.stageTarget.classList.toggle("deck-stage--stacked", stacked);

    const gutter = this.stageTarget.clientWidth < 640 ? 16 : 32;
    // The presenter window keeps the board to its left column.
    const room = this.presenterValue ? this.stageTarget.clientWidth * 0.62 : this.stageTarget.clientWidth;
    const width = room - gutter * 2;
    const height = this.stageTarget.clientHeight - gutter * 2;
    const scale = Math.max(
      Math.min(width / BOARD_WIDTH, height / BOARD_HEIGHT),
      0.1,
    );

    this.canvasTarget.style.setProperty("--deck-scale", scale.toFixed(4));
    this.canvasTarget.style.setProperty(
      "--deck-stack-zoom",
      Math.max((this.stageTarget.clientWidth - 24) / BOARD_WIDTH, 0.1).toFixed(
        4,
      ),
    );
    if (stacked) this.hydrateAll();
    this.sizeTiles();
  },

  get calm() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  },
};
